/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WalletTransactionItem } from './WalletTransactionItem';
import {
    WalletTransactionItemFromJSON,
    WalletTransactionItemFromJSONTyped,
    WalletTransactionItemToJSON,
    WalletTransactionItemToJSONTyped,
} from './WalletTransactionItem';
import type { WalletPagination } from './WalletPagination';
import {
    WalletPaginationFromJSON,
    WalletPaginationFromJSONTyped,
    WalletPaginationToJSON,
    WalletPaginationToJSONTyped,
} from './WalletPagination';

/**
 * Tournament wallet with balance and transactions
 * @export
 * @interface WalletResponse
 */
export interface WalletResponse {
    /**
     * 
     * @type {number}
     * @memberof WalletResponse
     */
    balance: number;
    /**
     * 
     * @type {Array<WalletTransactionItem>}
     * @memberof WalletResponse
     */
    transactions: Array<WalletTransactionItem>;
    /**
     * 
     * @type {WalletPagination}
     * @memberof WalletResponse
     */
    pagination: WalletPagination;
}

/**
 * Check if a given object implements the WalletResponse interface.
 */
export function instanceOfWalletResponse(value: object): value is WalletResponse {
    if (!('balance' in value) || value['balance'] === undefined) return false;
    if (!('transactions' in value) || value['transactions'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function WalletResponseFromJSON(json: any): WalletResponse {
    return WalletResponseFromJSONTyped(json, false);
}

export function WalletResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WalletResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'balance': json['balance'],
        'transactions': ((json['transactions'] as Array<any>).map(WalletTransactionItemFromJSON)),
        'pagination': WalletPaginationFromJSON(json['pagination']),
    };
}

export function WalletResponseToJSON(json: any): WalletResponse {
    return WalletResponseToJSONTyped(json, false);
}

export function WalletResponseToJSONTyped(value?: WalletResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'balance': value['balance'],
        'transactions': ((value['transactions'] as Array<any>).map(WalletTransactionItemToJSON)),
        'pagination': WalletPaginationToJSON(value['pagination']),
    };
}

